import { NavLink, useLocation } from 'react-router-dom';
import { addCustomPathToLink, generateKey, getCurrentPathname } from '../../functions';
import styles from './MainNavigation.module.scss';
import React from 'react';

const NavLinks = ({ prevPage, nextPage }) => {
  const location = useLocation();
  if (!prevPage && location.pathname != '/' && location.pathname != addCustomPathToLink('/')) prevPage = { slug: '/' };

  return [prevPage, nextPage]?.map(
    (menuItem) =>
      !!menuItem && (
        <NavLink
          to={addCustomPathToLink(`${!!menuItem?.slugPrefix ? menuItem?.slugPrefix + '/' : ''}${menuItem?.slug}`)}
          key={generateKey()}
          className={`${menuItem == prevPage ? styles.prevLink : styles.nextLink} ${styles.navLink}`}
          aria-label={menuItem?.name}
        />
      )
  );
};

export default NavLinks;
